export default "__VITE_ASSET__D4Ezr2MP__"